import { updateFingeringLabelContent } from './updateFingeringLabelContent';
import type { ScoreSystemData } from '../hooks/usePdfStateQueue';

/**
 * Update all PDF fingering overlays with new state data (for undo/redo)
 * @param newState - The new fingering state to apply
 */
export const updatePdfOverlaysWithState = (
  newState: ScoreSystemData[]
): void => {
  console.log('Updating PDF overlays with new state');

  newState.forEach((system, imageIndex) => {
    const overlayContainer = document.getElementById(
      `fingering-overlay-${imageIndex}`
    );
    if (!overlayContainer) {
      console.warn(
        `Overlay container not found for image ${imageIndex} during state update`
      );
      return;
    }

    // Find the SVG element
    const svg = overlayContainer.querySelector('svg');
    if (!svg) {
      console.warn(`SVG not found for image ${imageIndex} during state update`);
      return;
    }

    // Find all g elements (fingering groups)
    const gElements = svg.querySelectorAll('g[data-direction]');

    // Update each group with the new state
    system.fingeringGroupList.forEach((fingeringGroup, groupIndex) => {
      const targetGroup = gElements[groupIndex];
      if (!targetGroup) {
        console.warn(
          `Target group not found at index ${groupIndex} in image ${imageIndex} during state update`
        );
        return;
      }

      // Get all text elements in this group
      const textElements = targetGroup.querySelectorAll('text');

      // Separate main and alt fingerings from the new state
      const mainFingerings = fingeringGroup.fingeringNumList
        .filter((fn) => fn.mainFingering > 0)
        .map((fn) => fn.mainFingering);
      const altFingerings = fingeringGroup.fingeringNumList
        .filter((fn) => fn.altFingering > 0)
        .map((fn) => fn.altFingering);

      // Update text content for main fingerings
      mainFingerings.forEach((value, idx) => {
        if (textElements[idx]) {
          updateFingeringLabelContent(textElements[idx], value.toString());
        }
      });

      // Update text content for alt fingerings
      altFingerings.forEach((value, idx) => {
        const textIdx = mainFingerings.length + idx;
        if (textElements[textIdx]) {
          updateFingeringLabelContent(textElements[textIdx], value.toString());
        }
      });
    });
  });
};
